module.exports = __webpack_public_path__ + "static/media/browDownLeft.d41ddfa7.obj";